import React from 'react';
import Highlight from './search_page/Highlight';

export const TeaserSnippet = ({ text, query, url, children }) => {
  const decodeEntities = (str) =>
    new DOMParser().parseFromString(str || '', 'text/html').documentElement
      .textContent;

  const decodedText = decodeEntities(text);

  return (
    <p className="news-search-snippet news-teaser-text">
      <Highlight text={decodedText} query={query} />
      <a href={url}>
        <i className="fas fa-chevron-right" />
      </a>
      {children}
    </p>
  );
};

export default TeaserSnippet;
